import React, { Dispatch, DispatchWithoutAction, FC } from 'react';
import { ArrayField } from 'react-hook-form';

import { useI18n } from 'i18n';
import Button from 'core/react/general/form/Button';
import { StringEnumerationField } from './string-enumeration-field';

interface IStringEnumerationSelectProps {
  isDisabled: boolean;
  fields: Partial<ArrayField<Record<string, string>, 'id'>>[];
  addStringEnumeration: DispatchWithoutAction;
  removeStringEnumeration: Dispatch<number>;
}

export const StringEnumerationSelect: FC<IStringEnumerationSelectProps> = (props) => {
  const { isDisabled, fields, addStringEnumeration, removeStringEnumeration } = props;

  const { fc } = useI18n();

  return (
    <div>
      {fields.map((field, index) => (
        <StringEnumerationField
          key={field.id}
          fieldIndex={index}
          isDisabled={isDisabled}
          remove={removeStringEnumeration}
        />
      ))}
      <Button disabled={isDisabled} onClick={addStringEnumeration}>
        {fc('add')}
      </Button>
    </div>
  );
};
